var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserMyCollections = function SvgUserMyCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23H6V6h17zM9 20h11V9H9zm33 3H25V6h17zm-14-3h11V9H28zm-5 22H6V25h17zM9 39h11V28H9zm33 3H25V25h17zm-14-3h11V28H28z"
  })));
};
export default SvgUserMyCollections;